import { useCurrentCart } from "Store/cart";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { isAdviceProductOnCart } from "./utils";

export const useIsAdviceProduct = (product: InsuranceProduct): boolean => {
  const cart = useCurrentCart();

  return isAdviceProductOnCart(product, cart);
};
